import { render } from "./ActiveQuizView.vue?vue&type=template&id=1e5923aa"
import script from "./ActiveQuizView.vue?vue&type=script&lang=js"
export * from "./ActiveQuizView.vue?vue&type=script&lang=js"

import "./ActiveQuizView.vue?vue&type=style&index=0&id=1e5923aa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__